import React from 'react';
import { useTranslation } from 'react-i18next';
import Header from '../components/Header/Header';
import SEO from '../components/SEO/SEO';
import './LegalPage.css';

function TermsOfUsePage() {
  const { t } = useTranslation();

  return (
    <div className="legal-page">
      <SEO page="terms" />
      <Header />

      <div className="legal-container">
        <div className="legal-content">
          <h1 className="legal-title">{t('legal.terms.title', 'Terms of Use')}</h1>
          <p className="legal-updated">{t('legal.terms.lastUpdated', 'Last updated')}: January 2025</p>

          <section className="legal-section">
            <h2>{t('legal.terms.acceptanceTitle', 'Acceptance of Terms')}</h2>
            <p>{t('legal.terms.acceptanceText', 'By accessing and using TraderMap (tradermap.io), you accept and agree to be bound by these Terms of Use. If you do not agree to these terms, please do not use our website.')}</p>
          </section>

          <section className="legal-section">
            <h2>{t('legal.terms.descriptionTitle', 'Description of Service')}</h2>
            <p>{t('legal.terms.descriptionText', 'TraderMap provides cryptocurrency market data, analytics, and tracking tools including:')}</p>
            <ul>
              <li>{t('legal.terms.service1', 'Real-time whale trade monitoring')}</li>
              <li>{t('legal.terms.service2', 'Cryptocurrency price tracking and charts')}</li>
              <li>{t('legal.terms.service3', 'Market sentiment indicators')}</li>
              <li>{t('legal.terms.service4', 'ETF flow tracking')}</li>
              <li>{t('legal.terms.service5', 'Trading leaderboards and analytics')}</li>
              <li>{t('legal.terms.service6', 'Investment calculators')}</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>{t('legal.terms.dataTitle', 'Data and Information')}</h2>
            <p>{t('legal.terms.dataText1', 'All data, information, and content on TraderMap is provided "as is" for informational purposes only. While we strive to provide accurate and timely information, we make no warranties or representations regarding:')}</p>
            <ul>
              <li>{t('legal.terms.data1', 'The accuracy, completeness, or reliability of any data')}</li>
              <li>{t('legal.terms.data2', 'The timeliness of information updates')}</li>
              <li>{t('legal.terms.data3', 'The availability of our services')}</li>
            </ul>
            <p>{t('legal.terms.dataText2', 'Data may be delayed, incomplete, or contain errors. You should verify any information before making decisions based on it.')}</p>
          </section>

          <section className="legal-section">
            <h2>{t('legal.terms.noAdviceTitle', 'No Financial Advice')}</h2>
            <p>{t('legal.terms.noAdviceText', 'The content on TraderMap is for informational purposes only and does not constitute financial, investment, trading, or any other type of advice. We are not financial advisors, and you should consult qualified professionals before making any investment decisions.')}</p>
          </section>

          <section className="legal-section">
            <h2>{t('legal.terms.userTitle', 'User Responsibilities')}</h2>
            <p>{t('legal.terms.userText', 'By using TraderMap, you agree to:')}</p>
            <ul>
              <li>{t('legal.terms.user1', 'Use the service only for lawful purposes')}</li>
              <li>{t('legal.terms.user2', 'Not attempt to disrupt or interfere with the website')}</li>
              <li>{t('legal.terms.user3', 'Not use automated tools or bots without permission')}</li>
              <li>{t('legal.terms.user4', 'Not redistribute or commercialize our data without authorization')}</li>
              <li>{t('legal.terms.user5', 'Take responsibility for your own trading decisions')}</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>{t('legal.terms.ipTitle', 'Intellectual Property')}</h2>
            <p>{t('legal.terms.ipText', 'All content, design, graphics, compilation, and other materials on TraderMap are protected by copyright, trademark, and other intellectual property laws. You may not copy, modify, distribute, or reproduce any content without our prior written consent.')}</p>
          </section>

          <section className="legal-section">
            <h2>{t('legal.terms.scrapingTitle', 'Data Scraping and Automation')}</h2>
            <p>{t('legal.terms.scrapingText', 'Unauthorized scraping, crawling, or automated collection of data from TraderMap is strictly prohibited. Commercial use of our data requires written authorization. Violation of this policy may result in legal action and permanent access restriction.')}</p>
          </section>

          <section className="legal-section">
            <h2>{t('legal.terms.thirdPartyTitle', 'Third-Party Links')}</h2>
            <p>{t('legal.terms.thirdPartyText', 'Our website may contain links to third-party websites or services. We are not responsible for the content, privacy policies, or practices of any third-party sites. Use of external links is at your own risk.')}</p>
          </section>

          <section className="legal-section">
            <h2>{t('legal.terms.limitationTitle', 'Limitation of Liability')}</h2>
            <p>{t('legal.terms.limitationText', 'To the maximum extent permitted by law, TraderMap and its operators shall not be liable for any direct, indirect, incidental, special, consequential, or punitive damages arising from your use of or inability to use the website, including but not limited to:')}</p>
            <ul>
              <li>{t('legal.terms.liability1', 'Financial losses from trading decisions')}</li>
              <li>{t('legal.terms.liability2', 'Data inaccuracies or delays')}</li>
              <li>{t('legal.terms.liability3', 'Service interruptions or downtime')}</li>
              <li>{t('legal.terms.liability4', 'Security breaches or unauthorized access')}</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>{t('legal.terms.indemnificationTitle', 'Indemnification')}</h2>
            <p>{t('legal.terms.indemnificationText', 'You agree to indemnify and hold harmless TraderMap and its operators from any claims, damages, losses, or expenses arising from your use of the website or violation of these terms.')}</p>
          </section>

          <section className="legal-section">
            <h2>{t('legal.terms.modificationsTitle', 'Modifications')}</h2>
            <p>{t('legal.terms.modificationsText', 'We reserve the right to modify these Terms of Use at any time. Changes will be effective immediately upon posting. Your continued use of the website after changes constitutes acceptance of the modified terms.')}</p>
          </section>

          <section className="legal-section">
            <h2>{t('legal.terms.terminationTitle', 'Termination')}</h2>
            <p>{t('legal.terms.terminationText', 'We may terminate or suspend your access to TraderMap at any time, without prior notice, for conduct that we believe violates these Terms of Use or is harmful to other users or our business interests.')}</p>
          </section>

          <section className="legal-section">
            <h2>{t('legal.terms.governingTitle', 'Governing Law')}</h2>
            <p>{t('legal.terms.governingText', 'These Terms of Use shall be governed by and construed in accordance with applicable laws, without regard to conflict of law principles.')}</p>
          </section>

          <section className="legal-section">
            <h2>{t('legal.terms.contactTitle', 'Contact Us')}</h2>
            <p>{t('legal.terms.contactText', 'If you have any questions about these Terms of Use, please contact us at:')}</p>
            <p className="legal-contact">
              <a href="mailto:support@tradermap.io">support@tradermap.io</a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}

export default TermsOfUsePage;
